    /**
    This tooltip module is designed to work only .lendingtree.com domain. For other domain, please disable the same.
    */
<template>
    <span>
        <button :id="triggerBtnId" :class="tooltipClass" :data-target="TooltipId" :aria-label="ariaLabel" @click="handleClick()">{{ tooltipText }}</button>

        <!-- use the modal component, pass in the prop -->
        <a11y-modal :id="TooltipId" :showLoader="ShowLoader">
            <template #h4> {{ GlossaryHeading }} </template>
            <!-- you can use custom content here to overwrite default content -->
            <div slot="body" v-html="ModalBody"></div>
        </a11y-modal>
    </span>
</template>
<script>
    import a11yModal from '../helpers/a11y-modal';
    import A11yModal from './a11y-modal.vue';
    import makeHttpRequest from '../helpers/ajax';
    import wwwUrlEnv from '../helpers/www-url-env';
    import DebtManagement from '../constants/debt-management-tooltip';

    export default {
        props: {
            tooltipLink: {
                default: '',
            },
            tooltipClass: {
                default: 'lt-icons lt4-QuestionOutline calc-question a11y-modal-trigger',
            },
            tooltipText: {
                default: '',
            },
            tooltipId: {
                type: String,
                default: '',
            },
            glossaryHeading: {
                default: '',
            },
            uniqueId: {
                default: '',
            },
            showTooltipLoader: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                ShowLoader: false,
                ShowModal: false,
                ModalBody: '',
                target: '',
                TooltipId: this.tooltipId,
                TooltipLink: this.tooltipLink,
                GlossaryHeading: this.glossaryHeading,
            };
        },
        components: {
            A11yModal,
        },
        methods: {
            handleClick() {
                if (typeof this.tooltipLink !== 'undefined' && this.tooltipLink.indexOf('dma-') >= 0) {
                    this.createModal(DebtManagement.DebtManagementTooltip, this);
                    this.ShowModal = true;
                    return false;
                }
                if (this.target === '') {
                    this.fetchData();
                    this.ShowModal = true;
                    return false;
                }
                if (window.location.hostname.indexOf('.lendingtree') < 0) {
                    const href = `https://www.lendingtree.com/glossary/${this.tooltipLink}`;
                    window.open(href);
                }
                return false;
            },
            fetchData() {
                this.ModalBody = '';
                if (this.showTooltipLoader) this.ShowLoader = true;
                if (typeof this.tooltipLink != 'undefined') {
                    const url = `${wwwUrlEnv.getWWWURL()}/wp-json/glossary/v1?slug=${this.tooltipLink}`;
                    const glossaryMoreLink = `${wwwUrlEnv.getWWWURL()}/glossary/`;
                    const request = {
                        url, storage_key: this.tooltipLink, expTime: 15 * 60 * 1000, headers: { 'x-requested-with': 'XMLHttpRequest' },
                    };
                    return makeHttpRequest(request).then((response) => {
                        const glossary = JSON.parse(response);
                        if (glossary.term !== 'Not Found') {
                            this.GlossaryHeading = glossary[0].term;
                            this.ModalBody += `<div id="detail" class="detail">${glossary[0].value}</div>`;
                            this.ModalBody += `<div class="content-navigation-ahead"><a href="${glossaryMoreLink}" target="_blank">More Glossary Terms</a></div></div>`;
                        } else {
                            this.ModalBody = '<h3>Glossary Not found.</h3>';
                        }
                        this.ShowLoader = false;
                    }, (error) => {
                        this.ShowLoader = false;
                        console.warn(`There is some issue with network call, please try again${error}`);
                    });
                }
                return false;
            },
            createModal(response, self) {
                const glossary = response;
                self.ModalBody = '';
                if (glossary.term !== 'Not Found') {
                    this.GlossaryHeading = glossary[0].term;
                    self.ModalBody += `<div id="detail" class="detail">${glossary[self.tooltipLink].value}</div>`;
                    self.ModalBody += '<div class="content-navigation-ahead"><a href="/glossary/" target="_blank">More Glossary Terms</a></div></div>';
                } else {
                    self.ModalBody = '<h3>Glossary Not found.</h3>';
                }
            },
        },
        created() {
            if (window.location.hostname.indexOf('.lendingtree') < 0) {
                this.target = '_blank';
            }
        },
        computed: {
            ariaLabel() {
                return `View information for ${this.TooltipLink.replace(/-/g, ' ').toLowerCase()}`;
            },
            triggerBtnId() {
                const randomId = Math.ceil(Math.random() * 100);
                return `${this.TooltipId}_btn_${randomId}`;
            },
        },
        mounted() {
            setTimeout(() => {
                a11yModal.initModal();
            }, 1000);
            this.TooltipId = this.uniqueId !== '' ? this.uniqueId : this.TooltipLink.replace(/\s+/g, '-').replace(/:/g, '').toLowerCase();
        },
    };
</script>
    <style src="../../assets/styles/a11yModal.scss" lang="scss"></style>
